<div class="container">
  <div class="ibox m-t">
    <div class="ibox-title">
      <h5>Status das Conexões</h5>
      <div class="ibox-tools">
        <a ng-click="status.refresh()" ng-hide="status.loading">
          <i class="fa fa-refresh"></i>
          Atualizar
        </a>
      </div>
    </div>
    <div class="ibox-content" ng-hide="status.accessPoints.length">
      <p class="text-cinza text-center">
        <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
      </p>
    </div>
    <div class="ibox-content" ng-show="status.accessPoints.length">
      <div class="alert alert-danger" ng-show="status.offlineAPs().length">
        <h4>
          <i class="fa fa-exclamation-triangle"></i>
          Servidores offline
        </h4>
        <ul>
          <li ng-repeat="ap in status.offlineAPs()">
            <a ng-href="{{ap.scheme}}://{{ap.host}}:{{ap.port_api}}/">
              {{ap.host}}
            </a>
            ({{ap.status.response}})
          </li>
        </ul>
      </div>
      <p>
        Total de servidores: <strong>{{status.accessPoints.length}}</strong>
      </p>
      <p ng-if="status.loading" class="text-muted">
        Servidores verificados: <strong>{{status.checkedAmt()}}</strong>
        <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i>
      </p>
      <p class="text-success">
        Servidores online: <strong>{{status.onlineAmt()}}</strong>
      </p>
      <p class="text-danger">
        <i class="fa fa-exclamation-triangle"></i>
        Servidores offline: <strong>{{status.offlineAmt()}}</strong>
      </p>
      <hr>
      <uib-accordion>
        <div class="panel-default" uib-accordion-group heading="Servidores verificados">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>AP</th>
                <th>WEB</th>
                <th>Response</th>
                <th>Timing</th>
                <th>Último Backup</th>
                <th>Banco | Sistema</th>
                <th>Último Registro</th>
                <th>Data/Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="ap in status.accessPoints" ng-class="{'danger': status.isOffline(ap)}">
                <td>
                  <a ng-href="{{ap.scheme}}://{{ap.host}}:{{ap.port_api}}/" target="_blank">
                    {{ap.host}}
                  </a>
                </td>
                <td>
                  <a ng-href="http://{{ap.url_web}}/" target="_blank">
                    {{ap.url_web}}
                  </a>
                </td>
                <td>
                  <span ng-show="ap.status">{{ap.status.response}}</span>
                  <i class="fa fa-spinner fa-pulse fa-fw text-cinza" ng-hide="ap.status"></i>
                </td>
                <td>
                  <span ng-show="ap.status">{{ap.status.duration}} ms</span>
                  <i class="fa fa-spinner fa-pulse fa-fw text-cinza" ng-hide="ap.status"></i>
                </td>
                <td>
                  {{ap.information.last_backup_imagens | date:'dd/MM/yy'}}
                </td>
                <td>
                  {{ap.information.versao_banco}} | {{ap.information.versao_sistema}}
                </td>
                <td>
                  {{ap.information.last_register_date | date:'dd/MM/yy HH:mm'}}
                </td>
                <td>
                  {{ap.information.time | date:'dd/MM/yy HH:mm'}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </uib-accordion>
    </div>
  </div>
</div>
